import { dayjs } from "@equidefi/i18n";

const TIME_ZONE = "America/New_York";

export const formatSystemDownTimestamp = (timestamp: string | Date | null | undefined): string | null => {
  if (!timestamp) return null;
  const d = dayjs(timestamp).tz(TIME_ZONE);
  return d.isValid() ? d.format("MMMM Do, YYYY - h:mmA z") : null;
};
